<template>
  <div class="go">
    <div class="mypays">
      <div class="upbox clearfix">
        <div class="lbox">
          <h2>当前余额</h2>
          <p>￥{{pay.balance}}</p>
        </div>
        <div class="rbox">
          <div class="btn" @click="dialogVisible = true">立即充值</div>
          <div class="ti" @click="tixianVisible = true">提现</div>
        </div>
      </div>
      <div class="table">
        <el-table :data="recordlist.arr" style="width: 100%">
          <el-table-column prop="date" label="时间" width="286"></el-table-column>
          <el-table-column prop="money" label="金额" width="286">
            <template slot-scope="scope">
              <div>{{scope.row.isIncrease == 1?'+':'-'}}{{scope.row.money}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="title" label="操作" width="286">
            <template slot-scope="scope">
              <div>{{scope.row.title | starfilters}}</div>
              <div>{{scope.row.title | endfilters}}</div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="pageing">
      <span class="spansx" @click="pageindex" :class="[page == 1?'on':'']">首页</span>
      <el-pagination
        small
        layout="prev, pager, next"
        prev-text="上一页"
        next-text="下一页"
        :background="true"
        :total="recordlist.total_pages==null?1:recordlist.total_pages"
        :page-size="1"
        @current-change="currentchange"
        :current-page="page"
      ></el-pagination>
      <span @click="pageend" class="spansx" :class="[page == recordlist.total_pages?'on':'']">尾页</span>
    </div>

    <!-- 充值 -->
    <el-dialog title="余额充值" :visible.sync="dialogVisible" width="403" :before-close="handleClose">
      <div class="recharge">
        <h3>充值金额</h3>
        <ul class="clearfix">
          <li
            :class="[idx==index?'on':'']"
            @click="moneyfunc(index)"
            v-for="(item,index) in numlist"
            :data-id="index"
            :key="index"
          >
            ￥{{item.money}}
            <i class="el-icon-check"></i>
          </li>
        </ul>
        <h3>支付方式</h3>
        <ul class="clearfix on">
          <li :class="[idxpay == 0?'on':'']" @click="idxpay = 0">
            <img src="http://web.wit100.net/yunmipcimg/003_03.png" alt srcset />
            <i class="el-icon-check"></i>
          </li>
          <li :class="[idxpay == 1?'on':'']" @click="idxpay = 1">
            <img src="http://web.wit100.net/yunmipcimg/01-01-03_05.png" alt srcset />
            <i class="el-icon-check"></i>
          </li>
        </ul>
        <el-button type="primary" class="mainbtn" @click="closePopup">立即充值</el-button>
        <p>
          点击充值即同意
          <span>《厚课网用户协议》</span>
        </p>
      </div>
    </el-dialog>
    <!-- 充值结束 -->

    <!-- 提现 -->
    <el-dialog title="余额提现" :visible.sync="tixianVisible" width="403" :before-close="handleClose">
      <div class="recharge">
        <div class="tititle">
          提现金额（当前可提现
          <span>￥{{this.pay.balance}}</span> ）
        </div>
        <el-input placeholder="请输入内容" v-model="tixian">
          <template slot="append">
            <span @click="banknow">全部提现</span>
          </template>
        </el-input>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="银行卡信息" name="0"></el-tab-pane>
          <el-tab-pane label="支付宝信息" name="1"></el-tab-pane>
        </el-tabs>
        <div class="inputbox" v-if="activeName==0">
          <el-input v-model="word" placeholder="输入银行卡号"></el-input>
          <el-input v-model="name" placeholder="输入持卡人姓名"></el-input>
          <el-input v-model="bankname" placeholder="输入开户行名称"></el-input>
        </div>
        <div class="inputbox" v-if="activeName==1">
          <el-input v-model="zhi_name" placeholder="输入支付宝账户姓名"></el-input>
          <el-input v-model="zhi_word" placeholder="输入支付宝帐号"></el-input>
        </div>
        <el-button type="primary" class="mainbtn on" v-if="activeName==0" @click="bank">确认提现</el-button>
        <el-button type="primary" class="mainbtn on" v-if="activeName==1" @click="alipay">确认提现</el-button>
        <p>提现手续费{{pay.withdrawRate}}%，到账金额会扣除</p>
      </div>
    </el-dialog>
    <!-- 提现结束 -->
    <el-dialog
      title="支付宝支付"
      :visible.sync="zhifubaoqueren"
      width="443px"
      class="paysbox"
      @close="close"
    >
      <p>
        请在打开的页面完成支付，
        <span>支付完成前，请不要关闭此窗口。</span>
      </p>
      <div class="btns">
        <span @click="orderthree(false)">已完成支付</span>
        <span class="on" @click="orderthree(false)">支付遇到问题</span>
      </div>
    </el-dialog>
    <el-dialog
      title="微信支付"
      :visible.sync="weixinqueren"
      width="443px"
      :before-close="handleClose"
      class="paysbox"
    >
      <p>请使用微信扫码支付</p>
      <div class="code">
        <Qrcode :msg="link" class="code_img"></Qrcode>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  Table,
  TableColumn,
  Pagination,
  Dialog,
  Button,
  MessageBox,
  Input,
  Tabs,
  TabPane,
  Message,
  Loading
} from "element-ui";
import utilFile from "@/ace/ace.js";
import Qrcode from "@/components/Qrcode.vue";
export default {
  components: {
    Qrcode,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Pagination.name]: Pagination,
    [Dialog.name]: Dialog,
    [Button.name]: Button,
    [MessageBox.name]: MessageBox,
    [Input.name]: Input,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    [Message.name]: Message
  },
  inject: ["reload"], // 引入方法
  data() {
    return {
      dialogVisible: false,
      tixianVisible: false,
      tixian: "",
      input: "",
      activeName: 0,
      pay: {},
      idx: 0,
      idxpay: 0,
      numlist: [], //金额列表
      money: null,
      changeid: null,
      urllist: "",
      isSetPayPwd: null,
      showpopup: false, //支付宝控制引导用户是否支付完成的弹窗

      zhifubaoqueren: false,
      weixinqueren: false,
      link: null,

      /*银行卡*/
      name: "",
      bankname: "", //开户行名称
      word: null,
      money: "",
      /**/

      /*支付宝*/
      zhi_name: "",
      zhi_word: "",
      /**/

      page: 1,
      recordlist: {},
      timeout: null //定时查询
    };
  },
  watch: {
    activeName() {
      this.tixian = "";
    },
    page(newvalue) {
      this.page = newvalue;
      this.balancerecords();
    },
    weixinqueren() {
      if (this.weixinqueren == false) {
        clearInterval(this.timeout);
      }
    }
  },
  filters: {
    starfilters(data) {
      var sub = data.slice(4, -4);

      return sub;
    },
    endfilters(data) {
      var sub;
      if(data.indexOf("级收入") != -1){
        sub = data.substring(data.length - 4);
      }else{
        sub = ' ';
      }
      return sub
    }
  },
  methods: {
    //分页
    currentchange(page) {
      this.page = page;
    },
    pageindex() {
      this.page = 1;
    },
    pageend() {
      this.page = this.recordlist.total_pages;
    },
    handleClose(done) {
      MessageBox.confirm("确认关闭？")
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    handleClick(tab, event) {},
    banknow() {
      this.tixian = this.pay.balance;
    },
    bank() {
      //银行卡提现
      if (
        this.name != "" &&
        this.bankname != "" &&
        this.word != null &&
        this.tixian != ""
      ) {
        var data = utilFile.encrypt(
          JSON.stringify({
            type: 1,
            account: this.word,
            name: this.name,
            money: this.tixian,
            bankName: this.bankname
          })
        );

        this.$axios({
          method: "post",
          url: `/api/user.withdraw?parameter=${data}`,
          data: {},
          withCredentials: true,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
          }
        }).then(res => {
          if (res.data.code == 200) {
            Message.closeAll();
            Message({
              showClose: true,
              message: res.data.msg,
              type: "success"
            });

            setTimeout(() => {
              this.reload();
            }, 1000);
          } else {
            Message.closeAll();
            Message({
              showClose: true,
              message: res.data.msg,
              type: "error"
            });
          }
        });
      } else {
        Message.closeAll();
        Message({
          showClose: true,
          message: "不能为空",
          type: "warning"
        });
      }
    },
    alipay() {
      //支付宝
      if (this.zhi_name != "" && this.zhi_word != null && this.tixian != "") {
        var data = utilFile.encrypt(
          JSON.stringify({
            type: 2,
            account: this.zhi_word,
            name: this.zhi_name,
            money: this.tixian
          })
        );
        this.$axios({
          method: "post",
          url: `/api/user.withdraw?parameter=${data}`,
          data: {},
          withCredentials: true,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
          }
        }).then(res => {
          if (res.data.code == 200) {
            Message.closeAll();
            Message({
              showClose: true,
              message: res.data.msg,
              type: "success"
            });
            setTimeout(() => {
              this.reload();
            }, 1000);
          } else {
            Message.closeAll();
            Message({
              showClose: true,
              message: res.data.msg,
              type: "error"
            });
          }
        });
      } else {
        Message.closeAll();
        Message({
          showClose: true,
          message: "不能为空",
          type: "warning"
        });
      }
    },
    async closePopup() {
      await this.changeidfunc();
      if (this.idxpay == 0) {
        //支付宝
        await this.baopay();
      } else {
        //微信
        await this.wxpay();
        // 异步更新数据
        this.timeout = setInterval(() => {
          this.$globel.loding = true;
          this.orderthree(true);
        }, 1000);
      }
    },
    close() {
      localStorage.removeItem("showpopup"); //订单页  微信h5支付 引导用户是否支付完成的弹窗
    },
    wxpay() {
      //微信支付

      var data = utilFile.encrypt(
        JSON.stringify({
          id: this.changeid,
          pay_from: "pc",
          pay_type: "recharge"
        })
      );
      this.$axios({
        method: "post",
        url: `/api/join.wxpay?parameter=${data}`,
        data: {},
        withCredentials: true,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      }).then(res => {
        this.link = null;
        let totaldata = JSON.parse(utilFile.decrypt(res.data.data));
        this.link = totaldata;
        this.weixinqueren = true;
      });
    },
    baopay() {
      //支付宝支付
      localStorage.setItem("showpopup", true);
      localStorage.setItem("baoid", this.changeid);
      this.$router.push({
        path: "/baopay",
        query: { mode: "recharge" }
      });
    },
    moneyfunc(shu) {
      this.idx = shu;
      this.money = this.numlist[shu].money;
    },
    async changeidfunc() {
      //获取订单id

      var data = utilFile.encrypt(
        JSON.stringify({
          money: this.money
        })
      );
      await this.$axios({
        method: "post",
        url: `/api/join.yueRecharge?parameter=${data}`,
        data: data,
        withCredentials: true,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      }).then(res => {
        this.changeid = JSON.parse(utilFile.decrypt(res.data.data)).id;
        localStorage.setItem("orsid", this.changeid);
      });
    },
    agreementfuc(key) {
      var data = utilFile.encrypt(
        JSON.stringify({
          key
        })
      );
      this.$axios({
        method: "post",
        url: `/api/single.getKey?parameter=${data}`,
        data: {},
        withCredentials: true,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      }).then(res => {
        this.urllist = JSON.parse(utilFile.decrypt(res.data.data)).content;
      });
    },
    orderthree(wx) {
      //第三方接口校验 支付是否成功
      var data = utilFile.encrypt(
        JSON.stringify({
          id: localStorage.orsid,
          pay_type: "recharge"
        })
      );
      this.$axios({
        method: "post",
        url: `/api/join.checkResult?parameter=${data}`,
        data: data,
        withCredentials: true,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      }).then(res => {
        if (res.data.code == 90004) {
          if (wx == true) {
          } else {
            Message.closeAll();
            Message({
              showClose: true,
              message: res.data.msg,
              type: "warning"
            });
            setTimeout(() => {
              this.reload();
            }, 1000);
          }
          this.showpopup = false;
        } else {
          let obj = JSON.parse(utilFile.decrypt(res.data.data));
          if (obj.result == 0) {
            Message.closeAll();
            //支付失败 或者未支付
            Message({
              showClose: true,
              message: "支付失败 或者未支付",
              type: "warning"
            });
          } else {
            Message.closeAll();
            //成功
            Message({
              showClose: true,
              message: "支付成功",
              type: "success"
            });
            this.$globel.loding = false;
          }
          clearInterval(this.timeout);
          setTimeout(() => {
            this.reload();
          }, 1000);
        }

        localStorage.removeItem("showpopup"); //订单页  微信h5支付 引导用户是否支付完成的弹窗
      });
    },
    zong() {
      this.$axios({
        method: "post",
        url: `/api/user.balance`,
        data: {},
        withCredentials: true,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      }).then(res => {
        if (res.data.code == 999) {
          this.$router.push({
            path: "/logins"
          });
        } else {
          let pay = JSON.parse(utilFile.decrypt(res.data.data));
          this.pay = pay;
        }
      });
    },

    balancerecords() {
      //提现记录
      var data = {
        page: this.page
      };

      data = utilFile.encrypt(JSON.stringify(data));
      this.$axios({
        method: "post",
        url: `/api/user.balanceRecord?parameter=${data}`,
        data: {},
        withCredentials: true,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      }).then(res => {
        if (res.data.code == 999) {
          this.$router.push({
            path: "/logins"
          });
        }
        if (res.data.data != undefined) {
          let recordlist = JSON.parse(utilFile.decrypt(res.data.data));
          this.recordlist = recordlist;
        }
      });
    },
    moneynums() {
      this.$axios({
        method: "post",
        url: `/api/join.rechargeConfig`,
        data: {},
        withCredentials: true,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      }).then(res => {
        let numarr = JSON.parse(utilFile.decrypt(res.data.data));
        this.numlist = numarr.joinConfig;
        this.money = numarr.joinConfig[0].money;
        this.joinSingleKey = numarr.joinSingleKey;

        this.agreementfuc(numarr.joinSingleKey); //获取协议
      });
    }
  },
  mounted() {
    this.zong();
    this.moneynums();
    if (localStorage.showpopup) {
      this.zhifubaoqueren = true;
    }
    this.balancerecords();
  }
};
</script>

<style scoped>
.paysbox .el-dialog__header {
  text-align: left;
  padding-bottom: 20px;
  padding-top: 20px;
  background-color: #f8f8f8;
  font-size: 13px;
  line-height: 1em;
}

.paysbox .el-dialog {
  border-radius: 6px;
  overflow: hidden;
}

.paysbox .el-dialog__title {
  font-size: 12px;
}

.paysbox p {
  font-size: 14px;
  color: #000;
  margin: 44px 0;
}

.paysbox p span {
  color: red;
}

.paysbox .btns {
  text-align: center;
  font-size: 0;
  margin-bottom: 30px;
  cursor: pointer;
}

.paysbox .btns span {
  display: inline-block;
  width: 174px;
  line-height: 40px;
  color: #ffffff;
  border-radius: 6px;
  text-align: center;
  margin: 0 5px;
  background-color: #38a0ff;
  font-size: 14px;
}
.paysbox .btns span.on {
  background-color: #9fa5ad;
}

.paysbox .el-dialog__body {
  padding: 0;
}

.paysbox .code {
  width: 182px;
  border-radius: 6px;
  overflow: hidden;
  padding: 15px;
  border: 1px solid #e4e5e7;
  margin: auto;
  margin-bottom: 64px;
}
.mypays {
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.1);
  padding-bottom: 46px;
  margin-top: 36px;
}
.mypays .upbox {
  background-color: red;
  box-sizing: border-box;
  padding: 26px 30px;
}
.mypays .lbox {
  float: left;
}

.mypays .lbox h2 {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 28px;
  margin-top: 12px;
}
.mypays .lbox p {
  font-size: 30px;
  color: #ffffff;
  font-weight: bold;
}
.mypays .rbox {
  float: right;
  cursor: pointer;
}
.mypays .rbox .btn {
  width: 140px;
  line-height: 49px;
  font-size: 18px;
  color: #fb3636;
  background-color: #ffffff;
  border-radius: 50px;
  text-align: center;
  margin-bottom: 20px;
}
.mypays .rbox .ti {
  width: 140px;
  color: #ffffff;
  font-size: 18px;
  text-decoration: underline;
  text-align: center;
}

.table {
  box-sizing: border-box;
  padding: 0 36px;
  margin-top: 26px;
}

.go .recharge h3 {
  font-size: 14px;
  color: #000;
  margin-top: 28px;
  margin-bottom: 15px;
}

.go .recharge {
  box-sizing: border-box;
  padding: 0 17px;
}

.go .recharge ul {
  width: 100%;
}

.go .recharge ul li {
  width: 100px;
  line-height: 50px;
  border: 1px solid #9fa5ad;
  border-radius: 8px;
  overflow: hidden;
  margin-right: 11px;
  text-align: center;
  float: left;
  box-sizing: border-box;
  margin-bottom: 15px;
  position: relative;
  cursor: pointer;
}

.go .recharge ul li:nth-of-type(3n) {
  margin-right: 0;
}

.go .recharge ul li i {
  position: absolute;
  bottom: 0;
  right: 1px;
  font-size: 12px;
  color: #ffffff;
  display: none;
}

.go .recharge ul li.on {
  border: 1px solid #ff0e0e;
  color: red;
  font-weight: bold;
}

.go .recharge ul li.on::after {
  width: 0;
  content: "";
  height: 0;
  border-style: solid;
  border-width: 0 0 23px 23px;
  border-color: transparent transparent #ff0e0e transparent;
  position: absolute;
  bottom: 0;
  right: 0;
}

.go .recharge ul li.on i {
  display: block;
  z-index: 100;
}

.go .recharge ul.on li {
  height: 73px;
  width: 160px;
  border: 1px solid #f3f5f7;
  background-color: #f3f5f7;
  margin-right: 6px;
}

.go .recharge ul.on li img {
  width: 93px;
  height: 34px;
  margin: auto;
  margin-top: 19px;
}

.go .recharge ul.on li.on {
  border: 1px solid #ff0e0e;
}

.go .recharge ul.on li:last-of-type {
  margin-right: 0;
}

.go .el-dialog {
  cursor: pointer;
}

.go .el-dialog p {
  text-align: center;
  font-size: 14px;
  color: #6d6d6d;
}

.go .el-dialog p span {
  font-size: 14px;
  color: #38a0ff;
}

.go .tititle {
  text-align: left;
  font-size: 14px;
  color: #000;
  margin-bottom: 18px;
}

.go .tititle span {
  color: #ff0e0e;
  font-weight: bold;
}
</style>
<style>
.table .el-table .cell {
  text-align: center;
}

.table .el-table th {
  background-color: #fbfbfc;
}

.go .el-dialog {
  border-radius: 6px;
  overflow: hidden;
}

.go .el-dialog__header {
  padding: 0 20px;
  line-height: 50px;
  background-color: #f8f8f8;
}

.go .el-dialog__headerbtn {
  top: 0px;
}
.go .el-dialog__title {
  font-size: 13px;
}

.paysbox .el-dialog__headerbtn {
  top: 0px;
}

.go .el-dialog {
  width: 400px;
}

.go .mainbtn.el-button {
  font-size: 16px;
  width: 100%;
  height: 46px;
  margin-top: 35px;
  margin-bottom: 20px;
}

.go .mainbtn.el-button.on {
  font-size: 16px;
  width: 100%;
  height: 46px;
  margin-top: 0px;
  margin-bottom: 20px;
}

.go .el-input-group__append {
  background-color: transparent;
  font-size: 14px;
  color: #38a0ff;
  text-decoration: underline;
}

.go .el-input-group > .el-input__inner {
  border-right: 0;
}

.go .el-tabs__item {
  height: 33px;
  line-height: 33px;
}
.go .el-tabs__nav {
  margin-bottom: 15px;
  margin-top: 17px;
}

.go .el-tabs__nav-wrap::after {
  display: none;
}

.go .el-tabs__header {
  margin-bottom: 0;
}

.go .inputbox .el-input {
  margin-bottom: 20px;
}

.table .el-table tr td:nth-of-type(2){
  font-size: 20px;
  color: #ff0000;
  font-weight: bold;
}
</style>